











































import { Component, mixins } from 'nuxt-property-decorator';

import { PageContentMixin } from '@/composables/page-content';

import { mutations } from '@/components/animate/BodyBackground/BodyBackgroundState';

import { ScenkonstStaffContentDataFragment } from '@/graphql/generated';

@Component
export default class WorkerDetailPage extends mixins(PageContentMixin<ScenkonstStaffContentDataFragment>()) {
  created () {
    mutations.setColors({
      color: null,
      textColor: '#000',
      bgColor: '#E8E9EA', // color("gray", 10);
    });
  }

  get page () {
    return {
      title: `${this.pageContent.firstName} ${this.pageContent.lastName}`,
      slug: '',
      backgroundColor: 'light',
    };
  };

  get category () {
    return this.pageContent.category?.name;
  }
}
